// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  listingId: __t.u64().primaryKey().name("listing_id"),
  seller: __t.identity(),
  kind: __t.string(),
  familyKey: __t.string().name("family_key"),
  itemKey: __t.string().name("item_key"),
  name: __t.string(),
  statsJson: __t.string().name("stats_json"),
  propsJson: __t.string().name("props_json"),
  quality: __t.u32(),
  ceiling: __t.u32(),
  componentsJson: __t.string().name("components_json"),
  serial: __t.string(),
  spawnId: __t.u64().name("spawn_id"),
  qty: __t.u32(),
  priceSov: __t.i64().name("price_sov"),
  active: __t.bool(),
  listedAt: __t.timestamp().name("listed_at"),
});
